import fontsCategories from '../constants/fonts-categories';

const getFontFallbackByCategory = (category) => {
  switch (category) {
    case fontsCategories.SANS_SERIF:
      return '"Roboto", var(--font-sans-serif-fallback)';
    case fontsCategories.SERIF:
      return '"Roboto Serif", var(--font-sans-serif-fallback)';
    case fontsCategories.MONOSPACE:
      return '"Roboto Mono", var(--font-sans-serif-fallback)';
    case fontsCategories.DISPLAY:
    case fontsCategories.HANDWRITING:
      return 'var(--font-serif-fallback)';
    default:
      return 'var(--font-sans-serif-fallback)';
  }
};

export default getFontFallbackByCategory;
